import styled from 'styled-components';
import { EngineSelectStyled } from '../EngineSelectStyled';
import { rem } from 'polished';

export const EngineSelectStyledAP = styled(EngineSelectStyled)`
 
    .isSelected {
        background: ${({ theme }) => theme.colors.primaryLight};
    }
`;
